<template>
  <!-- Formulář pro ověření certifikátu — UUID + soubor -->
  <Form :validation-schema="formValidationSchema" @submit="handleFormSend" autocomplete="off">

    <!-- Pole pro ID certifikátu -->
    <div class="create-cert-field mb-4">
      <label class="create-cert-label">{{ $t('cert.certID') }}</label>
      <Field
          type="text"
          class="create-cert-input"
          v-model="uuid"
          id="uuid"
          name="uuid"
          :placeholder="$t('cert.certID')"
          :label="$t('cert.certID')"
      />
      <ErrorMessage class="create-cert-error" name="uuid" />
    </div>

    <!-- Dropzone pro nahrání souboru k ověření -->
    <div class="create-cert-field mb-4">
      <div
          class="create-cert-dropzone"
          :class="{ 'create-cert-dropzone--active': isDragging, 'create-cert-dropzone--filled': file, 'create-cert-dropzone--error': fileError }"
          @dragover.prevent="isDragging = true"
          @dragleave.prevent="isDragging = false"
          @drop.prevent="onDrop"
          @click="$refs.files.click()"
      >
        <img :src="iconFile" alt="" class="create-cert-dropzone__icon">
        <span v-if="!file" class="create-cert-dropzone__text">
          {{ $t('cert.uploadFile') }}
        </span>
        <span v-else class="create-cert-dropzone__filename">{{ file.name }}</span>
        <input
            type="file"
            name="file"
            id="verif-file"
            ref="files"
            style="display: none"
            @change="onFileChanged($event)"
        />
      </div>
      <span v-if="fileError" class="create-cert-error">{{ $t('cert.fileRequired') }}</span>
    </div>

    <!-- Tlačítko pro spuštění ověření -->
    <div class="d-flex justify-content-end">
      <button type="submit" class="btn btn-primary create-cert-btn-submit" :disabled="verifying">
        <span v-if="verifying" class="spinner-border spinner-border-sm me-2" role="status"></span>
        {{ verifying ? $t('general.verifying') : $t('cert.verify') }}
      </button>
    </div>

  </Form>
</template>

<script>
import http from '@/http';
import iconFile from '/public/img/new-design/icons/file.svg';

export default {
  components: {},

  data() {
    return {
      file: null,
      fileError: false,
      isDragging: false,
      verifying: false,
      // UUID může být předvyplněno z URL parametru
      uuid: this.$route.params.hash || this.$route.query.uuid || null,
      formValidationSchema: {
        uuid: 'required|min:10',
      },
      iconFile,
    };
  },

  methods: {
    onDrop(event) {
      this.isDragging = false;
      const dropped = event.dataTransfer.files[0];
      if (dropped) {
        this.file = dropped;
        this.fileError = false;
      }
    },

    onFileChanged() {
      this.file = this.$refs.files.files[0] || null;
      if (this.file) this.fileError = false;
    },

    verifyCert() {
      this.verifying = true;
      const formData = new FormData();
      formData.append('file', this.file);
      http
          .post('/certs/' + this.uuid + '/verification', formData)
          .then((response) => {
            // Výsledek ověření předáme nadřazené komponentě přes emitter
            this.emitter.emit('certChecked', response.data);
            this.verifying = false;
          })
          .catch(() => {
            this.verifying = false;
          });
    },

    handleFormSend() {
      if (!this.file) {
        this.fileError = true;
        return;
      }
      this.verifyCert();
    },
  },
};
</script>